import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getList, getDetail, add, update, remove, grant, grantTree, getTopTree } from "@/api/system/topmenu";
import { mapGetters } from "vuex";
import iconList from "@/config/iconList";
export default {
  data: function data() {
    return {
      form: {},
      box: false,
      query: {},
      loading: true,
      props: {
        label: "title",
        value: "key"
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      menuGrantList: [],
      menuTreeObj: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogWidth: 900,
        dialogClickModal: false,
        column: [{
          label: "菜单名",
          prop: "name",
          search: true,
          rules: [{
            required: true,
            message: "请输入菜单名",
            trigger: "blur"
          }]
        }, {
          label: "菜单图标",
          prop: "source",
          type: "icon",
          slot: true,
          iconList: iconList,
          rules: [{
            required: true,
            message: "请输入菜单图标",
            trigger: "click"
          }]
        }, {
          label: "菜单编号",
          prop: "code",
          search: true,
          rules: [{
            required: true,
            message: "请输入菜单编号",
            trigger: "blur"
          }]
        }, {
          label: "菜单排序",
          prop: "sort",
          type: "number",
          slot: true,
          rules: [{
            required: true,
            message: "请输入菜单排序",
            trigger: "blur"
          }]
        }]
      },
      data: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.topmenu_add, false),
        viewBtn: this.vaildData(this.permission.topmenu_view, false),
        delBtn: this.vaildData(this.permission.topmenu_delete, false),
        editBtn: this.vaildData(this.permission.topmenu_edit, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
    idsArray: function idsArray() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids;
    }
  }),
  methods: {
    submit: function submit() {
      var _this = this;

      var menuList = this.$refs.treeMenu.getCheckedKeys();
      grant(this.idsArray, menuList).then(function () {
        _this.box = false;

        _this.$message({
          type: "success",
          message: "操作成功!"
        });

        _this.onLoad(_this.page);
      });
    },
    rowSave: function rowSave(row, done, loading) {
      var _this2 = this;

      add(row).then(function () {
        _this2.onLoad(_this2.page);

        _this2.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate: function rowUpdate(row, index, done, loading) {
      var _this3 = this;

      update(row).then(function () {
        _this3.onLoad(_this3.page);

        _this3.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDel: function rowDel(row) {
      var _this4 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id);
      }).then(function () {
        _this4.onLoad(_this4.page);

        _this4.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    handleDelete: function handleDelete() {
      var _this5 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this5.ids);
      }).then(function () {
        _this5.onLoad(_this5.page);

        _this5.$message({
          type: "success",
          message: "操作成功!"
        });

        _this5.$refs.crud.toggleSelection();
      });
    },
    handleMenuSetting: function handleMenuSetting() {
      var _this6 = this;

      if (this.selectionList.length !== 1) {
        this.$message.warning("只能选择一条数据");
        return;
      }

      this.menuTreeObj = [];
      grantTree().then(function (res) {
        _this6.menuGrantList = res.data.data.menu;
        getTopTree(_this6.ids).then(function (res) {
          _this6.menuTreeObj = res.data.data.menu;
          _this6.box = true;
        });
      });
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this7 = this;

      if (["edit", "view"].includes(type)) {
        getDetail(this.form.id).then(function (res) {
          _this7.form = res.data.data;
        });
      }

      done();
    },
    sortChange: function sortChange(row) {
      var _this8 = this;

      update(row).then(function () {
        _this8.onLoad(_this8.page);
      }, function (error) {
        window.console.log(error);
      });
    },
    searchReset: function searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this9 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(function (res) {
        var data = res.data.data;
        _this9.page.total = data.total;
        _this9.data = data.records;
        _this9.loading = false;

        _this9.selectionClear();
      });
    }
  }
};